module.exports = __webpack_public_path__ + "media/after_result.efa820a7.mp3";